// dependencies
import { Map, List } from "immutable";
import { getMatchedRouteKeyValue } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";

export const getPageSize = (state) => getUI(state).get("pageSize", 1);
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);
export const getCurrentQuery = (state) => getUI(state).get("currentQuery", "");
export const getUserBreadcrumbs = (state) => getUI(state).get("breadcrumbs", List());
export const getBreadcrumbsCount = (state) => getUI(state).get("breadcrumbsCount", 1);
export const getSelectedUser = (state, notSetValue = null) => getUI(state).get("selectedUser", notSetValue);

// filters
export const getFiltersMap = (state) => {
	const ui = getUI(state);
	return ui.get("filters", Map());
};

/** Gets a userID from the URL */
export const getSelectedUserID = (state) => {
	const urlParams = getMatchedRouteKeyValue(state, "userID", null);
	return urlParams;
};
